import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {RecaptchaComponent} from 'ng-recaptcha';
import {UsuarioService} from 'src/app/services/usuario.service';
import {NotificationsService} from 'angular2-notifications';
import {GoogleAnalyticsService} from 'src/app/services/google-analytics.service';
import {ConfigurationService} from 'src/app/services/configuration.service';
import {GenericValidator} from 'src/app/generic-validator';
import {Mask} from "../../model/mask.model";

@Component({
  selector: 'app-esqueci',
  templateUrl: './esqueci.component.html',
  styleUrls: ['./esqueci.component.css']
})
export class EsqueciComponent implements OnInit {
  @ViewChild('openModal', {static: true}) openModal: ElementRef;
  @ViewChild('openSMSModal', {static: true}) openSMSModal: ElementRef;
  @ViewChild('rc1', { static: true }) rc1: RecaptchaComponent;
  @ViewChild('rc2', { static: true }) rc2: RecaptchaComponent;
  @ViewChild('rc3', { static: true }) rc3: RecaptchaComponent;
  cpfmask = Mask.cpf;
  model: any = {};
  reCaptchaKey: string;
  showSpinner = false;
  showSpinnerReenvio = false;
  sms = false;
  captchaToken: string = '';
  phone: String = "";
  agenciaSelecionada: Number;

  constructor(
    private usuarioService: UsuarioService,
    public googleAnalyticsService: GoogleAnalyticsService,
    private _notificationService: NotificationsService,
    private configService: ConfigurationService
    ) {
      this.onConfigLoad = this.onConfigLoad.bind( this );
      configService.loadConfigurations().subscribe( this.onConfigLoad );
    }

    ngOnInit() {
      this.googleAnalyticsService.eventEmitter("esqueci-senha", "load", "page-load", 1);

      RecaptchaComponent.prototype.ngOnDestroy = function() {
        if (this.subscription) {
          this.subscription.unsubscribe();
        }
      }
    }

    enviarEmail(reenvio = false) {
      this.model.email = this.model.email.trim();
      if (!this.model.token || this.model.token === '') {
        this.rc1.reset();
        this._notificationService.error('Login', "Selecione a opção 'Não sou um robô' ante de realizar o login.");
        return;
      }

      if (! this.isValidEmail( this.model.email ) ) {
        this.rc1.reset();
        this._notificationService.error('Login', "Por favor coloque um e-mail válido.");
        return;
      }

      this.model.agencyId = this.agenciaSelecionada;

      this.googleAnalyticsService.eventEmitter("esqueci-senha", "button-click", "nova-senha", 2);
      this.showSpinner = !reenvio;
      this.showSpinnerReenvio = reenvio;
      this.usuarioService.postEsqueciSenha(this.model).subscribe(() => {
        this.googleAnalyticsService.eventEmitter("esqueci-senha", "button-click", "sucesso", 3);
        if (!reenvio) {
          this.openModal.nativeElement.click();
          this.rc1.reset();
          this.showSpinner = false;
        } else {
          this.rc1.reset();
          this.showSpinnerReenvio = false;
        }
      }, (err) => {
        this.rc1.reset();
        this.googleAnalyticsService.eventEmitter("esqueci-senha", "button-click", "erro", 4);
        this.showSpinner = false;
      });
    }

    sendSMS() {
      this.rc3.reset();
      this.usuarioService.sendSms(this.model).subscribe(() => this._notificationService.success("SMS Enviado","Siga as instruções para recuperar sua senha"),() => this._notificationService.error("Erro ao enviar SMS","Tente novamente"));
    }

    resolved(captchaResponse: string) {
      if(captchaResponse) {
        this.model.token = captchaResponse;
        this.captchaToken = captchaResponse;
      }
    }

    enviarSMS() {
      this.model.cpf = this.model.cpf.trim();
      if (!this.model.token || this.model.token === '') {
        this._notificationService.error('Login', "Selecione a opção 'Não sou um robô' antes de realizar o login.");
        this.rc2.reset();
        return;
      }

      if (!GenericValidator.isValidCpf(this.model.cpf)) {
        this._notificationService.error('Login', "Por favor coloque um CPF válido.");
        this.rc2.reset();
        return;
      }

      this.model.agencyId = this.agenciaSelecionada;

      this.googleAnalyticsService.eventEmitter("esqueci-senha", "button-click", "nova-senha", 2);
      this.showSpinner = true;
      this.model.cpf = this.model.cpf.replace(".", "").replace(".", "").replace("-", "");
      this.usuarioService.getPartialPhone(this.model).subscribe(usuario => {
        this.model.token = undefined;
        if(usuario.phoneNumber) {
          this.phone = usuario.phoneNumber;
          this.openSMSModal.nativeElement.click();
        } else this._notificationService.error('CPF não localizado', "Confira o CPF e tente novamente");
        this.showSpinner = false;
        this.rc2.reset();
      }, () => {
        this._notificationService.error('Erro ao buscar', "Confira o CPF e tente novamente");
        this.showSpinner = false;
        this.rc2.reset();
      });
    }

    // brought to you by
    // https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
    isValidEmail( email: String ) {
      return GenericValidator.isValidEmail( email );
    }

    onConfigLoad( config ) {
      this.reCaptchaKey = config.reCaptchaKey;
      this.agenciaSelecionada = config.agencyId;
      this.sms = config.features.sms;
    }
  }
